import { PASTEL, PastelId } from '@/ui/illustrations/palette'

interface PhotoGlyphProps {
  x?: number
  y?: number
  width?: number
  height?: number
  color?: PastelId
  radius?: number
}

export function PhotoGlyph({ x = 4, y = 4, width = 40, height = 40, color = PastelId.Sky, radius = 3 }: PhotoGlyphProps) {
  const sunRadius = Math.max(0.7, Math.min(width, height) * 0.09)
  return (
    <g>
      <rect className="dark:fill-opacity-[0.85]" x={x} y={y} width={width} height={height} rx={radius} fill={PASTEL[color]} />
      <circle cx={x + width * 0.27} cy={y + height * 0.27} r={sunRadius} fill="none" />
      <path d={`M${x + width * 0.08} ${y + height * 0.78} L${x + width * 0.36} ${y + height * 0.5} L${x + width * 0.56} ${y + height * 0.68} L${x + width * 0.73} ${y + height * 0.48} L${x + width * 0.94} ${y + height * 0.74}`} fill="none" />
    </g>
  )
}
